export const QTY_LIMIT = 25;
export const YES = 'YES';
export const NO = 'NO';
export const REQUEST = 'request';
export const RENT = 'rent';
export const NOT_AVAILABLE = 'not available';
export const IMAGE_SPECS = {
    HEIGHT: 56,
    WIDTH: 56
}
export const imageStaticPath = 'catClass';
export const CONSUMABLES_LISTING_VIEW_COUNTS = {
    ACCESSORIES: {
        MOBILE: 4,
        LARGE_DEVICE: 6,
        ITEMS_PER_COLUMN: {
            MOBILE: 4,
            LARGE_DEVICE: 3
        },
        COLUMNS: {
            MOBILE: 1,
            LARGE_DEVICE: 2,
        }
    },
    ADDONS: {
        ALL_DEVICES: 6,
        COLUMNS: {
            MOBILE: 1,
            LARGE_DEVICE: 2,
        },
        ITEMS_PER_COLUMN: {
            MOBILE: 6,
            LARGE_DEVICE: 3
        }
    }
}
